<template>
  <v-dialog :value="value" width="500px" @input="$emit('input', $event)" @click:outside="closeDialog">
    <v-card>
      <v-card-title class="pb-0">
        <span class="table-card-title">Importação realizada com sucesso!</span> <br />
        <p class="subtitle ma-0" style="word-break: break-word">Confira as alterações realizadas:</p>
      </v-card-title>
      <v-card-text class="px-0">
        <v-row no-gutters>
          <v-col class="pa-0">
            <v-data-table :items="items" :headers="headers" disable-filtering disable-pagination disable-sort hide-default-footer>
              <template v-slot:item="{ item }">
                <tr>
                  <td class="pl-6">{{ item.change }}</td>
                  <td class="pr-9 text-right">{{ item.quantity }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
        <mf-action-buttons
          :primary-button="{
            text: 'Fechar',
            action: closeDialog,
            isVisible: true,
          }"
          class="pr-4"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: Boolean,
    successResponse: Object,
  },
  computed: {
    headers() {
      return [
        {
          text: 'Alteração',
          value: 'change',
          align: 'left',
          class: 'pl-6',
        },
        {
          text: 'Quantidade de produtos',
          value: 'quantity',
          align: 'right',
          class: 'pr-9',
        },
      ]
    },
    items() {
      return [
        { change: 'Produtos criados', quantity: this.successResponse.created },
        { change: 'Produtos alterados', quantity: this.successResponse.updated },
      ]
    },
  },
  methods: {
    closeDialog() {
      this.$emit('input', false)
    },
  },
}
</script>
